import React from 'react';

import Icon from '../../icons/Icon';

import scss from './ActionType.module.scss';

function ActionType({ selectedAction, actionOptions, isShowGroupLabel = false }) {
  const selectedActionAndGroup = actionOptions.reduce((acc, group) => {
    const action = group.options.find((action) => action?.value === selectedAction);
    if (action) {
      return { ...action, groupLabel: group.groupLabel };
    }
    return acc;
  }, null);

  if (!selectedActionAndGroup) {
    return <span />;
  }

  return (
    <span className={scss.actionType}>
      {selectedActionAndGroup.Icon ? (
        <Icon icon={selectedActionAndGroup.Icon} className={scss.actionTypeIcon} disableCommonStyles />
      ) : null}
      <span>
        {isShowGroupLabel && selectedActionAndGroup.groupLabel ? `${selectedActionAndGroup.groupLabel} ` : ''}
        {selectedActionAndGroup.label}
      </span>
    </span>
  );
}

export default ActionType;
